import { isDevAuthBypassEnabled } from "./auth";

const TABLE_VISUAL_V1 = "v1";
const TABLE_VISUAL_STORAGE_KEY = "alphasearch:tableVisualVersion";

function readIsV2TableVisualFromStorage() {
  if (typeof window === "undefined" || !window.localStorage) return true;
  try {
    const stored = window.localStorage.getItem(TABLE_VISUAL_STORAGE_KEY);
    return stored !== TABLE_VISUAL_V1;
  } catch (_error) {
    return true;
  }
}

/** V1 table visual — low remaining credits (medium usage state). */
export const DEV_CREDITS_PAYLOAD_V1 = {
  balance: 151,
  monthly_credits: 100,
  standalone_credits: 51,
  monthly_credit_allowance: 1000,
  monthly_credit_reset_at: "2026-09-01T00:00:00Z",
};

/** V2/V3 table visual — healthier remaining credits for contrast with V1. */
export const DEV_CREDITS_PAYLOAD_V2 = {
  balance: 493,
  monthly_credits: 430,
  standalone_credits: 63,
  monthly_credit_allowance: 1000,
  monthly_credit_reset_at: "2026-08-01T00:00:00Z",
};

function buildPayloadFromTotal(balance) {
  const monthlyCredits = Math.min(100, balance);
  const standaloneCredits = Math.max(0, balance - monthlyCredits);

  return {
    balance,
    monthly_credits: monthlyCredits,
    standalone_credits: standaloneCredits,
    monthly_credit_allowance: 1000,
    monthly_credit_reset_at: "2026-09-01T00:00:00Z",
  };
}

/**
 * Local-dev-only fallback when the credits balance API is unavailable.
 * Override with REACT_APP_DEV_CREDITS_BALANCE (e.g. 0, 50, 151) to test UI states.
 *
 * @param {{ isV2TableVisual?: boolean }} [options]
 */
export function getDevCreditsBalancePayload(options = {}) {
  if (!isDevAuthBypassEnabled()) return null;

  const { isV2TableVisual = readIsV2TableVisualFromStorage() } = options;

  const rawOverride = process.env.REACT_APP_DEV_CREDITS_BALANCE;
  if (rawOverride !== undefined && String(rawOverride).trim() !== "") {
    const balance = Number(rawOverride);
    if (!Number.isFinite(balance) || balance < 0) return null;
    return buildPayloadFromTotal(balance);
  }

  return isV2TableVisual
    ? { ...DEV_CREDITS_PAYLOAD_V2 }
    : { ...DEV_CREDITS_PAYLOAD_V1 };
}
